import { Button, Spinner } from "@zapier/design-system";
import { useState } from "react";
import styles from "./NewCanvasButton.module.css";

const NewCanvasButton = () => {
  const [isCreatingNew, setIsCreatingNew] = useState(false);

  return (
    <Button
      color="secondary"
      size="small"
      href="/app/canvas/new"
      onClick={() => setIsCreatingNew(true)}
    >
      <div className={styles.newCanvasButtonContent}>
        {isCreatingNew ? (
          <>
            <Spinner size="small" color="dark" />
            Creating...
          </>
        ) : (
          "New"
        )}
      </div>
    </Button>
  );
};

export default NewCanvasButton;
